import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Couimg from "../assets/img/oneimg1.png";
import Couimgg from "../assets/img/oneimg2.png";
import Image1 from "../assets/img/courtest1.png";
import Image2 from "../assets/img/courtest4.png";
import Image3 from "../assets/img/courtest3.png";
import Image4 from "../assets/img/courtest2.png";

import Video1 from '../assets/video/video1.mp4';
import Video2 from '../assets/video/video2.mp4';
import Video3 from '../assets/video/video3.mp4';
import Video4 from '../assets/video/video4.mp4';
import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import Playbtn from '../assets/img/play.png';

import onebg from '../assets/img/styling/thewed.jpg';
import Icon1 from '../assets/img/one/icon1.png';
import Icon2 from '../assets/img/one/icon2.png';
import Icon3 from '../assets/img/one/icon3.png';
import Icon4 from '../assets/img/one/icon4.png';

import Icon5 from '../assets/img/one/icon5.jpg';
import Icon6 from '../assets/img/one/icon6.jpg';
import Icon7 from '../assets/img/one/icon7.jpg';
import Icon8 from '../assets/img/one/icon8.jpg';
import Icon9 from '../assets/img/one/icon9.jpg';
import Icon51 from '../assets/img/icon51.png';
import Icon61 from '../assets/img/icon61.png';
import Icon71 from '../assets/img/icon71.png';
import Icon81 from '../assets/img/icon81.png';
import Icon91 from '../assets/img/icon91.png';

import imgch from '../assets/img/styling/img7.png';
import imgch1 from '../assets/img/styling/ward1.png';

import SeoHelmet from "../components/SeoHelmet";
import iconstrt from '../assets/img/iconstartt.png';
import CommonModal from "../components/CommonModal";

const Thebridal = () => {
 

const [activeVideo, setActiveVideo] = useState(null);
const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: ""
});

    
      const handleOpenModal = (videoSrc) => {
        setActiveVideo(videoSrc); // Set the active video source
      };
    
      const handleCloseModal = () => {
        setActiveVideo(null); // Clear the active video source
      };

     


      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      };

       
    
      const handleRazorpayPayment = (courseType) => {

        if (!formData.name.trim()) {
          alert("Please enter your name.");
          return;
        }
        if (!formData.email.trim()) {
          alert("Please enter your email.");
          return;
        }
        if (!formData.phone.trim()) {
          alert("Please enter your phone number.");
          return;
        }
        const amount = courseType === "online" ? 50000 : 100000; // ₹500 for online, ₹1000 for offline
        const description = courseType === "online" ? "Online Course" : "Offline Course";

        const options = {
          key: "rzp_live_RqikICjLlTbO4w", // Replace with your Razorpay Key ID
          amount: amount * 100, // Amount in paise (1000 = ₹10)
          currency: "INR",
          name: "Bhavana Singh Courses",
          description: description,
          //image: "https://your-logo-url.com/logo.png", // Replace with your company logo URL
          handler: function (response) {
            const paymentId = response.razorpay_payment_id;
            //alert(`Payment successful. Payment ID: ${paymentId}`);
            window.location.href = `/success?payment_id=${paymentId}`;
          },
          prefill: {
            name: formData.name,
            email: formData.email,
            contact: formData.phone,
          },
          notes: {
            address: "Bhavana Singh",
          },
          theme: {
            color: "#3399cc",
          },
        };
    
        const razorpay = new window.Razorpay(options);
        razorpay.on("payment.failed", function (response) {
          alert(`Payment failed. Error: ${response.error.description}`);
        });
        razorpay.open();
      };


  const courses = {
    1: { title: "First Post", content: ( 
      <>
      
      </>
      ), },
    2: { title: "Second Post", content: ( 
      <>
      
      
      </>
      ), },
  };

 

  

  useEffect(() => {
       
    if (window.Swiper) {
      
     

      const swiper = new window.Swiper(".coursesslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3, 
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
          },
          // You can add more breakpoints if needed
        },
      
      });
       
     
    }
  }, []); 


  return (
    <>
 <SeoHelmet />
<CommonModal id="staticBackdrop" />

    <section className="oneofone_section thebridal" style={{ backgroundImage: `url(${onebg})` }}>
      <div class="container">
        <div className="contentone_outer">
          <div className="title_one">
            <h4>Every Detail, Every Outfit, Perfected</h4>
            <h2>The Bridal Trousseau and Styling</h2>
          </div>
          <div className="skillbox">
              <ul>
                <li><img src={Icon1}></img><spna>Zero Last-Minute<br></br> Bridal Panic</spna></li>
                <li><img src={Icon2}></img><spna>One Clear Vision,<br></br> No Confusion</spna></li>
                <li><img src={Icon3}></img><spna>Personal Taste,<br></br> Professionally Refined</spna></li>
                <li><img src={Icon4}></img><spna>Wedding Style Without<br></br> Family Stress</spna></li>
              </ul>
          </div>
          <div className="skillbox_content">
              <h3>The End Result </h3>
              <p>You’ll notice a complete shift in how you dress, walk, and carry yourself. Every outfit, gesture, and detail will<br></br> reflect confidence, style, and the ability to truly own the space you’re in. Your personal style will feel<br></br> effortless, intentional, and perfectly aligned with your personality and lifestyle</p>
          </div>
          <div className="onedetails thebride_detail">
              <div className="details_col">
                  <h2>Details:</h2>
                   <ul>
                      <li><h4>Duration</h4><spna>6 Months</spna></li>
                      <li><h4>location</h4><spna>In-Person or Online</spna></li>
                      <li><h4>fees</h4><spna> ₹5,00,000 + GST</spna></li>
                    </ul>
              </div>
              <div className="details_col-con">
                <div className="days_box">
                  <h3>1. Personal Consultation</h3>
                  <div className="daytext">
                     <p><b>.</b> Discover Your Unique Vision – Gain clarity on your personality, lifestyle, and bridal aspirations with Bhavana’s guidance.</p>
                     <p><b>.</b> Body & Style Alignment – Receive expert insights to ensure every look flatters your shape perfectly.</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3>2. Trousseau Planning</h3>
                  <div className="daytext">
                     <p><b>.</b> Complete Wardrobe Curation – Have your wedding, honeymoon, and investment pieces thoughtfully planned and organized.</p>
                     <p><b>.</b> Event-Ready Essentials – Enjoy a cohesive trousseau where every piece suits your style and celebrations.</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3>3. Event-Wise Outfit Selection</h3>
                  <div className="daytext">
                     <p><b>.</b> Function-Specific Styling – Get outfits curated for every wedding event, from sangeet to reception, flawlessly.</p>
                     <p><b>.</b> Flattering Silhouettes – Walk into every event in outfits that enhance your figure beautifully.</p>
                     
                  </div>
                </div>
                <div className="days_box">
                  <h3>4. Designer & Boutique Recommendations</h3>
                  <div className="daytext">
                     <p><b>.</b> Curated Designer Selection – Receive handpicked recommendations for designers and boutiques that match your style perfectly.</p>
                     <p><b>.</b> Personalized Fitting Guidance – Ensure each outfit’s colour, embroidery, and silhouette is tailored to you.</p>
                     
                  </div>
                </div>
                <div className="days_box">
                  <h3>5. Styling Visits & Approvals</h3>
                  <div className="daytext">
                     <p><b>.</b> Three Full-Day Styling Sessions – Enjoy immersive sessions with Bhavana to finalize your trousseau effortlessly.</p>
                     <p><b>.</b> Confident Outfit Decisions – Approve every outfit, accessory, and detail knowing each look is perfect.</p>
                     
                  </div>
                </div>
                <div className="days_box">
                  <h3>6. Makeup, Hair & Accessories</h3>
                  <div className="daytext">
                     <p><b>.</b> Personalized Glam Blueprint – Receive makeup, hair, and skincare guidance to feel radiant at every function.</p>
                     <p><b>.</b> Complete Accessories & Footwear – Have your jewellery, bags, lingerie, and shoes curated for every occasion.</p>
                     
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>

    <section className="whycho thebride_whycho">
      <div className="onembr_row">
        <div className="imageoner">
         <img className="oner1" src={imgch} ></img>
          <img className="oner2" src={imgch1} ></img>
        </div>
        <div className="contentoner">
          <h2>Why<br></br>Choose This Course</h2>
          <ul>
            <li><img className="num" src={Icon5} ></img><img className="num1" src={Icon51} ></img><span>Elevates Your Personality – Enhances your presence and confidence for every wedding moment.</span></li>
            <li><img className="num" src={Icon6} ></img><img className="num1" src={Icon61} ></img><span>Confidence in Every Step – Walk into events assured, poised, and fully in control.</span></li>
            <li><img className="num" src={Icon7} ></img><img className="num1" src={Icon71} ></img><span>Timeless Investment – Your wardrobe includes versatile pieces you can cherish beyond the wedding.</span></li>
            <li><img className="num" src={Icon8} ></img><img className="num1" src={Icon81} ></img><span>Memorable Impressions – Every look designed to make you unforgettable and truly radiant.</span></li>
            <li><img className="num" src={Icon9} ></img><img className="num1" src={Icon91} ></img><span>Seamless Cohesion – Outfits, makeup, and accessories harmoniously planned for every occasion.</span></li>
          </ul>
           <div className="btngroup">
                <a
                  href="/two-week-transformation"
                  className="terrs_btn" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                >
                  <img src={iconstrt} alt="" />
                  Get In Touch
                </a>
              </div>
        </div>
      </div>
    </section>

    
    {/* <section class="courses_details">
        <div class="container">
            <div class="row">
                <div class="col-md-6 d-flex align-items-center">
                    <div class="courses_content">
                        <h3>Be the Best Version Of</h3>
                        <h2>yourself!</h2>
                        <p>These tailor-made sessions focus on every aspect of your personal style and confidence, from your wardrobe and grooming to your body language and communication skills. With Bhavana’s expert guidance, you’ll embark on a journey to discover your most confident and polished self. Bhavana helps you become the best version of yourself, transforming you from ordinary to extraordinary. Eventually, you’ll have the confidence to own any room you walk into.</p>
                        <h4>What’s Included in Your Transformation Journey?</h4>
                        <div class="listcontent">
                            <div class="accordion" id="accordionExample">
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header" id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                 Day 1: Personalized Consultation
                                </h4>
                                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <ul>
                                    <li>In-depth consultation to understand your lifestyle, goals, and unique needs.</li>
                                    <li>Identification of problem areas and areas for improvement.</li>
                                  </ul>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingTwo" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                 
                                Day 2: Guided Shopping
                                  
                                </h4>
                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                 
                                  <ul>
                                    <li>Exclusive shopping session for makeup, skincare, and accessories.</li>
                                    <li>Recommendations tailored to your style, preferences, and personality.</li>
                                  </ul>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingThree" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                 
                                Day 3: Skincare, Makeup & Confidence Training
                                  
                                </h4>
                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                 
                                  <ul>
                                    
                                    <li>Hands-on practice with skincare routines and makeup techniques.</li>
                                    <li>Mastering body language and posture for a confident presence.</li>
                                  </ul>
                                  
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingfor" data-bs-toggle="collapse" data-bs-target="#collapsefor" aria-expanded="false" aria-controls="collapsefor">
                                 
                                Day 4: Wardrobe Building
                                  
                                </h4>
                                <div id="collapsefor" class="accordion-collapse collapse" aria-labelledby="headingfor" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  
                                  <ul>
                                    <li>Guided shopping for outfits, lingerie, boots, sunglasses, and more.</li>
                                    <li>Personalized styling advice to align with your body type and personality.</li>
                                  </ul>
                                  
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="courses_image">
                        <img src={Couimg} alt="" width="100%"/>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section class="courses_details onepagecontent">
        <div class="container">
            <div class="row">
            <div class="col-md-6">
                    <div class="courses_image imgcoud">
                        <img src={Couimgg} alt="" width="100%" />
                    </div>
                </div>
                <div class="col-md-6 d-flex align-items-center">
                    <div class="courses_content">
                      
                        <h4>What You Will Gain</h4>
                        <p>These tailor-made sessions focus on every aspect of your personal style and confidence, from your wardrobe and grooming to your body language and communication skills. With Bhavana’s expert guidance, you’ll embark on a journey to discover your most confident and polished self. Bhavana helps you become the best version of yourself, transforming you from ordinary to extraordinary. Eventually, you’ll have the confidence to own any room you walk into.</p>
                      
                        <ul className="secmbr">
                            <li><b>Enhanced Confidence:</b> Learn how to carry yourself with poise and assurance.</li>
                            <li><b>Refined Style:</b> Discover what works best for your hair, skin, body type,   and wardrobe.</li>
                            <li><b>Communication Skills:</b> Improve your speaking and interpersonal skills.</li>
                            <li><b>Polished Presence:</b> Build a lasting impression through your overall appearance and demeanour.</li>
                            <li><b>Extraordinary Transformation:</b> Transition from ordinary to extraordinary and gain the confidence to own every room you walk into.</li>
                        </ul>

                        <div class="courses_contentt">
                            <h4>The Unique Approach</h4>
                            <p>With years of experience transforming personalities and empowering individuals, Bhavana Singh’s practical, hands-on approach ensures you get the most out of every session. She combines her expertise in fashion, grooming, and personal development to create a transformation plan tailored just for you.</p>
                        </div>
                    </div>
                   
                </div>
                
            </div>
        </div>
      </section>
      <section class="courses_sli">
        <div class="container">
            <div class="courses-slide">
                <div class="slide_head">
                    <h3>TRANSFORMATION IN FOCUS </h3>
                    <h2>Sneak Peek and Success Stories</h2>
                    <p>Get a firsthand look at the journey with real moments captured from our live sessions. Watch as confidence builds, style transforms, and true presence unfolds. These reels offer a glimpse into the powerful impact of our program in action.</p>
                </div>
            </div>
            <div class="swiper coursesslide">
            <div class="swiper-wrapper">
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video1)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image1}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video2)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image2}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video3)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image3}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video4)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image4}/><img className='playbtnv' src={Playbtn}></img></a></div>
                   
                </div>
            </div>
            <div class="courses_btn">
                <a href="#" data-bs-toggle="modal" data-bs-target="#onlineCourseModal">Enrol Now</a>
                <a >Download Brochure</a>
            </div>
        </div>
      </section> */}

    <div className="modal fade" id="offlineCourseModal" tabIndex="-1" aria-labelledby="offlineCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Offline Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("offline")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div className="modal fade" id="onlineCourseModal" tabIndex="-1" aria-labelledby="onlineCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Online Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("online")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


      <div
        className={`modal fade ${activeVideo ? "show" : ""}`}
        id="videoModal"
        tabIndex="-1"
        aria-labelledby="videoModalLabel"
        aria-hidden={!activeVideo}
        style={{ display: activeVideo ? "block" : "none" }}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) {
            handleCloseModal();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered video_sectio">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="videoModalLabel">Bhavana Singh</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {activeVideo && (
                <iframe
                  id="videoFrame"
                  width="100%"
                  height="500"
                  src={`${activeVideo}#t=0&autoplay=1`}
                  frameBorder="0"
                  allow="autoplay"
                  allowFullScreen
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default Thebridal;
